const arr = [{
        id: '0',
        name: '工作台',
        icon: '',
        link: '/home',
        show: 0,
        code: '22A0',
        group: [{
            name: '工作台',
            code: '22A0',
            link: '/home',
            group: [{
                    name: '查看工作统计',
                    code: '22AA',
                },
                {
                    name: '查看作业统计和基础数据',
                    code: '22AB',
                },

                {
                    name: '查看实时故障',
                    code: '22AC',
                },

                {
                    name: '查看即将到期合同',
                    code: '22AD',
                },

                {
                    name: '查看电梯数据',
                    code: '22AE',
                },
                {
                    name: '查看维修工数据',
                    code: '22AF',
                },

                {
                    name: '查看行业新闻',
                    code: '22AG',
                },
                {
                    name: '查看公告信息',
                    code: '22AH',
                },
            ]
        }]
    },
    {
        id: '1',
        name: '基础管理',
        icon: 'icon-base',
        show: 0,
        code: '22B0',
        group: [{
                id: '1-1',
                name: '合同管理',
                show: 1,
                code: '22C0',
                link: '/contractManage',
                group: [{
                        name: '查询',
                        code: '22CA',
                    },
                    {
                        name: '查看详情',
                        code: '22CB',
                    },
                    {
                        name: '导出',
                        code: '22CC',
                    },
                ],
            },

            {
                id: '1-2',
                name: '辖区管理',
                show: 0,
                code: '22D0',
                link: '/areaManage',
                group: [{
                        name: '查询',
                        code: '22DA',
                    },
                    {
                        name: '新增',
                        code: '22DB',
                    },
                    {
                        name: '编辑',
                        code: '22DC',
                    },
                ]
            },
            {
                id: '1-3',
                name: '电梯管理员',
                show: 0,
                code: '22E0',
                link: '/employeeManage',
                group: [{
                        name: '查询',
                        code: '22EA',
                    },
                    {
                        name: '新增',
                        code: '22EB',
                    },
                    {
                        name: '编辑',
                        code: '22EC',
                    },
                    {
                        name: '查看位置',
                        code: '22ED',
                    },
                ]
            },
        ]
    },

    {
        id: '2',
        name: '电梯',
        show: 0,
        icon: 'icon-jindu',
        code: '22F0',
        group: [{
                id: '2-1',
                name: '电梯信息',
                show: 0,
                code: '22G0',
                link: '/certificateManage',
                group: [{
                        name: '查询',
                        code: '22GA'
                    },


                    {
                        name: '详情',
                        code: '22GB'
                    },
                    {
                        name: '实时状态',
                        code: '22GC'
                    },
                    {
                        name: '运行报告',
                        code: '22GD'
                    },
                ],
            },
            {
                id: '2-2',
                name: '故障信息',
                show: 0,
                code: '22H0',
                link: '/troubleMessage',
                group: [{
                        name: '查询',
                        code: '22HA'
                    },

                    {
                        name: '详情',
                        code: '22HB'
                    },
                    {
                        name: '故障记录',
                        code: '22HC'
                    },

                ],
            }
        ]
    },
    {
        id: '3',
        name: '维保',
        show: 0,
        icon: 'icon-jindu',
        code: '22J0',
        group: [{
                id: '3-1',
                name: '保养记录',
                show: 0,
                code: '22J0',
                link: '/maintaintManage',
                group: [{
                        name: '查询',
                        code: '22JA',
                    },
                    {
                        name: '详情',
                        code: '22JB',
                    },
                    {
                        name: '保养报告',
                        code: '22JC',
                    }, {
                        name: '导出',
                        code: '22JD',
                    }
                ]
            },
            {
                id: '3-2',
                name: '维修记录',
                show: 0,
                code: '22K0',
                link: '/repairManage',
                group: [{
                        name: '查询',
                        code: '22KA',
                    },
                    {
                        name: '导出',
                        code: '22KB',
                    },
                    {
                        name: '查看详情',
                        code: '22KC'
                    },
                    {
                        name: '查看停梯报告',
                        code: '22KD',
                    },
                    {
                        name: '查看维修报告',
                        code: '22KE',
                    },
                    {
                        name: '查看配件确认单',
                        code: '22KF',
                    },
                ]
            },
            {
                id: '3-3',
                name: '年检记录',
                show: 0,
                code: '22L0',
                link: '/annualManage',
                group: [{
                        name: '查询',
                        code: '22LA',
                    },
                    {
                        name: '导出',
                        code: '22LB',
                    },

                ]
            }
        ]
    },
    {
        id: '4',
        name: '运营管理',
        show: 0,
        code: '22M0',
        icon: 'icon-jindu',
        group: [{
            id: '4-1',
            name: '公告管理',
            show: 0,
            link: '/notice',
            code: '22N0',
            group: [{
                    name: '查询',
                    code: '22NA'
                },
                {
                    name: '公告类型',
                    code: '22NB'
                },
                {
                    name: '新增公告',
                    code: '22NC'
                },
                {
                    name: '预览',
                    code: '22ND'
                },
                {
                    name: '编辑',
                    code: '22NE'
                },
                {
                    name: '删除',
                    code: '22NF'
                }
            ]
        }]
    },
    {
        id: '5',
        name: '系统管理',
        show: 0,
        icon: 'icon-xitong',
        code: '22O0',
        group: [{
                id: '5-1',
                name: '权限管理',
                show: 0,
                link: '/permission',
                code: '22P0',
                group: [{
                        name: '查询',
                        code: '22PA'
                    },
                    {
                        name: '新增岗位',
                        code: '22PB'
                    },
                    {
                        name: '编辑',
                        code: '22PC'
                    },
                    {
                        name: '删除',
                        code: '22PD'
                    }
                ]
            },
            {
                id: '5-2',
                name: '企业信息',
                show: 0,
                link: '/companyInfo',
                code: '22Q0',
                group: [{
                        name: '查询',
                        code: '22QA'
                    },
                    {
                        name: '编辑',
                        code: '22QB'
                    }
                ]
            },
            {
                id: '5-3',
                name: '账号信息',
                show: 0,
                link: '/profile',
                code: '22R0',
                group: [{
                        name: '查询',
                        code: '22RA'
                    },
                    {
                        name: '修改用户名',
                        code: '22RB'
                    }
                ]
            },
        ]
    },







]
export default arr;



// WEBPACK FOOTER //
// ./src/components/aside/menuList.js